import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=21d447b7"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"
import style0 from "./TableView.vue?vue&type=style&index=0&id=21d447b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports